module.exports = __webpack_public_path__ + "img/logo-phuthanh-led.b83ce478.png";